module.exports = __webpack_public_path__ + "img/valimail-defend-ejaf-technology-canada.115c4255.png";